import React from "react";
import { Link as RouterLink } from "react-router-dom";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { Box, Button } from "@mui/material";
import { orderRoutes } from "areas/orders/order-routes";

export function ReturnToOrderButton({ odNumber }: { odNumber: string | null }) {
  if (!odNumber) {
    return null;
  }

  return (
    <Box sx={{ mb: 2 }}>
      <Button
        component={RouterLink}
        to={orderRoutes.detail(odNumber).root}
        variant="outlined"
        startIcon={<ArrowBackIcon />}
      >
        Return to order
      </Button>
    </Box>
  );
}
